export function matchCase(input: string, options: string[]): string {
  const normalisedInput = input.trim();
  const normalisedOptions = options.map((option) => option.trim());
  const matchedOption = normalisedOptions.find((option) => option.toLowerCase() === normalisedInput.toLowerCase());
  return matchedOption ?? input;
}
